import { OrderLineNotificationContract } from 'hooks/useOrderNotification/OrderLineNotificationContract'
import { Subject } from 'rxjs'

export enum OrderLineEventType {
    OnUpdateKDSStatusOrderLine,
}

export interface OrderLineEventArg {
    type: OrderLineEventType
    params: OrderLineNotificationContract[]
}

const orderLineEvent = new Subject<OrderLineEventArg>()

export default orderLineEvent
